var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list-item',[_c('item-content',{attrs:{"item":_vm.item}}),(!_vm.isActiveDelete)?_c('view-flag-item-action',{attrs:{"item":_vm.item}}):_vm._e(),_c('delete-item-action',{attrs:{"item":_vm.item},on:{"removeItem":_vm.removeItem,"isActiveOrInactiveDelete":_vm.setIsActiveDelete}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }